import React, { useEffect, Suspense, useState } from 'react';
import { prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { Login } from '@core/js/components/main/Login';
import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';
import { ManagedPopup } from '@core/js/components/common/Popup';
import { scrollService } from '@core/js/services/scroll.service';
import { useCombinedOnClose } from '@theme/js/components/common/PopupManager';
import { useAuthSelector, useAppSelector, useUserSelector } from '@core/js/store/hooks';

import style from './LoginPopup.scss';

const layerClassNames = {
    layout: style.layout
};

export const LoginPopup = ({ id, title, onClose, onLogin, controls }) => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const closePopup = useCombinedOnClose(onClose, id);
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));
    const rootPage = useAppSelector(prop('rootPage')); /* TotalCasino changes */
    const { pathname } = useLocation(); /* TotalCasino changes */
    const [prevPathname] = useState(pathname); /* TotalCasino changes */
    const rootPathname = [rootPage, '/'].includes(pathname); /* TotalCasino changes */

    useEffect(() => {
        if (!isLoggedIn || isLoginInProcess) {
            return;
        }

        if (onLogin) {
            onLogin();
        }

        closePopup();
        scrollService.scrollTo(0);
    }, [closePopup, isLoggedIn, onLogin, isLoginInProcess]);

    /* TotalCasino changes */
    useEffect(() => {
        if (!rootPathname && prevPathname !== pathname) {
            closePopup();
        }

    }, [closePopup, pathname, prevPathname, rootPage, rootPathname]);
    /* TotalCasino changes */

    return (
        <ManagedPopup
            id={id}
            title={title}
            classNames={style}
            controls={controls}
            onClose={closePopup}
            className={style.container}
            layerClassNames={layerClassNames}
        >
            <Suspense fallback="">
                <Login
                    className={`${style.loginPopupContainer} ${BACKBONE_APP_ROOT}`}
                />
            </Suspense>
            {/* TotalCasino changes */}
        </ManagedPopup>
    );
};
